module.exports = __webpack_public_path__ + "src/img/shareIcon.67a5289f.svg";